import { AMBIANCES } from '../render/Stage';
import type { App } from './App';

const DOT: Record<string, string> = { studio: '#f3c9b8', crepuscule: '#ff9a55', nuit: '#7f95ff', neon: '#ff3fb2' };

/** HUD du mode Jouer : ambiances lumineuses + aide qui s'efface après les premières interactions. */
export class PlayHud {
  private hint = document.getElementById('hint')!;
  private interactions = 0;

  constructor(app: App) {
    const box = document.getElementById('ambiances')!;
    let current = 'studio';
    for (const [id, a] of Object.entries(AMBIANCES)) {
      const b = document.createElement('button');
      b.className = 'amb' + (id === current ? ' active' : '');
      b.innerHTML = `<i style="color:${DOT[id] ?? '#fff'};background:${DOT[id] ?? '#fff'}"></i><span>${a.label}</span>`;
      b.title = a.label;
      b.setAttribute('aria-pressed', String(id === current));
      b.dataset.id = id;
      b.addEventListener('click', () => { if (id !== current) app.stage.setAmbiance(id); });
      box.appendChild(b);
    }
    // Reflète toute ambiance choisie (bouton, scénario…).
    app.stage.onAmbiance = (id) => {
      current = id;
      for (const el of box.querySelectorAll<HTMLElement>('.amb')) {
        const on = el.dataset.id === id;
        el.classList.toggle('active', on);
        el.setAttribute('aria-pressed', String(on));
      }
    };
    const dom = app.renderer.gl.domElement;
    const bump = () => { if (++this.interactions === 6) this.hint.classList.add('gone'); };
    dom.addEventListener('pointerup', bump);
    dom.addEventListener('wheel', bump, { passive: true });
  }

  setVisible(v: boolean) {
    document.getElementById('play-hud')!.style.opacity = v ? '1' : '0';
    document.getElementById('play-hud')!.style.pointerEvents = v ? '' : 'none';
  }
}
